import { DetailsService } from 'app/components/details/details.service';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { BrandsService } from '../../components/brands/brands.service';
import { FiltersService } from '../../components/filters/filters.service';
import { SessionService } from '../../components/common/session/session.service';
import { TranslateService } from '@ngx-translate/core';
import { UtilsService } from '../../components/utils/utils.service';
import { SearchService } from '../../components/search/search.service';
import { Subject, takeUntil } from 'rxjs';
import { CatalogueService } from '../../components/catalogue/catalogue.service';
import { SharedService } from '../../services/shared.service';
import { Title } from '@angular/platform-browser';
import { AnalyticsService } from 'app/components/analytics/analytics.service';
import { LoginService } from 'app/components/login/login.service';
import { FilterByLetterPipe } from '../../components/pipes/filter-by-letter.pipe';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.css']
})
export class BrandsComponent implements OnInit, OnDestroy {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  numElements: number = 0;
  oneElement: number = 1;
  filteredCount: number = 0;

  active: string = 'ALL';
  letters: Array<any> = ["ALL","A","B","C","D","E","F","G","H","I","J","K","L","M","N","O","P","Q","R","S","T","U","V","W","X","Y","Z", "Nº"];

  show:boolean = false;
  selectedView: string;

  favorites = {};
  
  items: any[] = []; // Asegúrate de definir tu array de items según tu necesidad
  itemsAux: any[] = [];
  eventData:any = null;
  names: any[] = [];
  namesAux: any[] = [];
  searchConfig: object = {};
  activeName = '';
  

  private readonly destroy$ = new Subject();


  constructor(private brandsService:BrandsService, public filtersService:FiltersService, private detailsService:DetailsService,
    private sessionService: SessionService, public utilsService:UtilsService, public searchService: SearchService, public translateService: TranslateService,
    public catalogueService:CatalogueService, private sharedService:SharedService, private titleService:Title, private analyticsService: AnalyticsService,
    public loginService: LoginService, private filterByLetterPipe: FilterByLetterPipe) {
      this.searchService.setItemsObs([]);
      this.items = [];
      this.searchConfig['page'] = 0;
    }

  getBrands(getBrandsIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.brandsService.getBrands(getBrandsIn)
      .subscribe((data: object) => {
        this.getBrandsOk(data);
      },
        error => {
          this.getBrandsError(error);
        });

  }

  getBrandsOk(data) {
    this.loader.count--;
    this.names = data;
    this.namesAux = this.names;
    this.updateFilteredCount();
  }

  getBrandsError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  unifiedSearch(unifiedSearchIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.searchService.unifiedSearch(unifiedSearchIn)
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: object) => {
        this.unifiedSearchOk(data);
      },
        error => {
          this.unifiedSearchError(error);
        });

  }

  unifiedSearchOk(data) {
    this.loader.count--;
    this.numElements = data['numElements'];
    this.searchService.setItemsObs(data.list);
    this.analyticsService.sendViewItemList(data.list, 'exhibitor', this.selectedView);
    this.searchService.setSearchConfig(this.searchConfig);
  }

  unifiedSearchError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }




  getProperty(key){
    return this.detailsService.getPropertyByKey(key, false);
  }

  isSponsored(item) {
    //const hasSelectedProperties = !this.helpers.isEmpty(this.searchStatus.selectedHierarchicalProperties);
    //const hasSelectedSectors = !this.helpers.isEmpty(this.searchStatus.selectedSectors);
    //if (!hasSelectedProperties && !hasSelectedSectors) {
    //  return this.item.sponsoredInHomePage;
    //}
    //return this.item.sponsoredByCategories || this.item.sponsoredBySector;
    
    return item.sponsoredByCategories || item.sponsoredBySector;
  }

  isFeatured(item) {
    return item.featured;
  }

  getBorderColor(isActive:boolean):boolean {
    return isActive ? this.eventData.mainColor : "#cbcbcb";
  }
  
  setActive(letter) {
    this.active = letter;
    this.show = false;
    this.updateFilteredCount();
  }

  // Calcula el número de marcas según la letra seleccionada reutilizando el pipe
  updateFilteredCount() {
    this.filteredCount = this.filterByLetterPipe.transform(this.names, this.active).length;
  }
  

  showCard(item){
    
    this.show = true;
    this.activeName = item;

    this.searchConfig = this.searchService.getSearchConfig();
    this.searchConfig = this.searchService.resetFilters();
    this.searchConfig['brand'] = this.activeName;
    this.searchConfig['filter'] = 'ONLY_EXHIBITORS';
    this.searchConfig['sapCode'] = this.eventData.sapCode;

    let unifiedSearchIn = this.searchConfig;

    this.unifiedSearch(unifiedSearchIn);

  }

  getFavoriteResources() {

    let eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
    let token = this.sessionService.get('token_' + eventData['sapCode'], true);
    let acount = JSON.parse(this.sessionService.get('profile_' + eventData['sapCode'], true) || '{}');

    let getFavoriteResourcesIn = {
      event:  eventData.eventName,
      token: token,
      user: acount.username
    };

    this.catalogueService.getFavoriteResources(getFavoriteResourcesIn)
        .subscribe((result) => {
              this.getFavoriteResourcesOk(result);
            },
            error => {
              console.log("[getFavoriteResources]ERROR",error);//FIXME sacar la parte del login
            });

  }

  getFavoriteResourcesOk(data: any){

    this.favorites = data;

  }

  filterNames(names: any[], keyword: string): string[] {
    const filtered: string[] = [];
    for (const key in names) {
        if (names[key].toLowerCase().includes(keyword.toLowerCase())) {
            filtered.push(names[key]);
        }
    }
    return filtered;
  }

  ngOnInit() {

    this.getFavoriteResources();

    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');

    this.searchService.resetFilters();

    this.searchConfig = this.searchService.getSearchConfig();
    this.searchConfig['brand'] = this.activeName;
    this.searchConfig['filter'] = 'ONLY_EXHIBITORS';
    this.searchConfig['sapCode'] = this.eventData.sapCode;
    
    this.searchService.setSearchConfig(this.searchConfig);

    this.getBrands({});

    this.filtersService.getSelectedView()
    .pipe(takeUntil(this.destroy$))
    .subscribe(data => {
      this.selectedView = data;
    });

    this.searchService.getItemsObs()
      .pipe(takeUntil(this.destroy$))
      .subscribe(items => {
        this.items = items;
    });

    this.filtersService.getKeyBrands()
    .pipe(takeUntil(this.destroy$))
    .subscribe(key => {
      this.names = this.filterNames(this.namesAux, key);
    });

    this.titleService.setTitle(this.catalogueService.getProperty('label'));

  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.complete();
  }

}
